import { connect } from 'react-redux';
import { compose } from 'redux';

import withReservationComponent from 'hocs/components/withReservation';
import { select } from 'property/properties.actions';
import { getDisabledDays } from 'property/calendar.selectors';
import { constants, showModal } from 'modal';

const mapStateToProps = (state, props) => ({
  // property which determines unclickable/unselectable area of calendar
  disabledDays: getDisabledDays(state, props),
});

const mapDispatchToProps = (dispatch) => ({
  openReservationModal(props) {
    dispatch(showModal(constants.RESERVATION, props));
  },
  select(props) {
    dispatch(select(props));
  },
});

const withReservation = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withReservationComponent
);

export default withReservation;
